import * as HelpConstants from "../constants";

const initialState = {
  isEnabled: false,
  isLoading: false,
  hasError: false,
  currentHelpKey: null,
  section: {
    title: "",
    content: "",
    faq_url: "",
    updatedAt: new Date()
  }
};

export function help(state = initialState, action) {
  switch (action.type) {
    case HelpConstants.TOGGLE_HELP:
      return Object.assign({}, state, {isEnabled: !state.isEnabled});
    case HelpConstants.FETCH_SECTION_STARTED:
      return Object.assign({}, state, {isLoading: true, section: initialState.section, currentHelpKey: action.helpKey});
    case HelpConstants.FETCH_SECTION_COMPLETED:
      return Object.assign({}, state, {isLoading: false, hasError: false, section: action.section});
    case HelpConstants.FETCH_SECTION_FAILED:
      return Object.assign({}, state, {isLoading: false, hasError: true});
    default:
      return state;
  }
}
